import React from 'react';
import { DisplayName } from 'features/users';

export const TransactionText = ({ transaction }) => {
  const {
    userId,
    status,
    transactionType,
    amount,
    currency,
    groupedSwaps = [],
    groupedTransfers = [],
  } = transaction;

  const swapSender = groupedSwaps.find(
    (t) => t.transactionMethod === 'swapSender'
  );
  const swapReceiver = groupedSwaps.find(
    (t) => t.transactionMethod === 'swapReciever'
  );

  const transferSender = groupedTransfers.find(
    (t) => t.transactionType === 'Send'
  );
  const transferReceiver = groupedTransfers.find(
    (t) => t.transactionType === 'Receive'
  );

  const amountString = `${currency || ''} ${amount?.toLocaleString()}`.trim();

  console.log(transactionType)

  if (['failed', 'pending', 'cancelled'].includes(status?.toLowerCase())) {
    const verb = {
      failed: 'has failed',
      pending: 'is pending',
      cancelled: 'has been cancelled',
      initiated: 'has initiated',
    }[status?.toLowerCase()];
    return (
      <>
        <DisplayName userId={userId} fullNameOnly />
        ’s {transactionType?.toLowerCase()} of {amountString} {verb}.
      </>
    );
  }

  if (swapSender && swapReceiver) {
    return (
      <div className="text-xs">
        <DisplayName userId={swapSender?.userId} className="text-xs" />{' '}
        <em>has swapped</em> {swapSender.currency}{' '}
        {swapSender.amount?.toLocaleString()} → {swapReceiver.currency}{' '}
        {swapReceiver.amount?.toLocaleString()}
      </div>
    );
  }

  if (transferSender && transferReceiver) {
    return `${
      transferSender.currency
    } ${transferSender.amount?.toLocaleString()} → ${
      transferReceiver.currency
    } ${transferReceiver.amount?.toLocaleString()}`;
  }

  const verbMap = {
    Deposit: 'deposited',
    Withdraw: 'withdrew',
    Swap: 'swapped',
    Transfer: 'transferred',
  };

  if (verbMap[transactionType]) {
    if (status === 'initiated') {
      return (
        <div className="text-xs">
          <DisplayName userId={userId} fullNameOnly />{' '}
          <em>has initiated withdraw of</em>{' '}
          <span className="hover:underline ">{amountString}</span>
        </div>
      );
    }
    return (
      <div className="text-xs">
        <DisplayName userId={userId} fullNameOnly className="text-xs" />{' '}
        <em>{verbMap[transactionType]}</em>{' '}
        <span className="hover:underline ">{amountString}</span>{' '}
      </div>
    );
  }

  return (
    <>
      <DisplayName userId={userId} fullNameOnly /> made a{' '}
      {transactionType?.toLowerCase()}
    </>
  );
};
